import type { DevRoute } from './dev-route';
import type { RouteParams } from './route-params';

const isParam = (segment: string): boolean => segment.startsWith(':');

const decode = (segment: string): string | undefined => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return undefined;
  }
};

export const matchRoute = <Path extends string>(
  route: DevRoute<Path>,
  request: Request
): RouteParams<Path> | undefined => {
  const expected = route.path.split('/');
  const actual = new URL(request.url).pathname.split('/').map((segment) => decode(segment));
  if (request.method !== route.method || expected.length !== actual.length) return undefined;
  const pairs = expected.map((segment, index) => [segment, actual[index]] as const);
  const matches = pairs.every(([segment, value]) =>
    isParam(segment) ? value !== undefined && value !== '' : segment === value
  );
  if (!matches) return undefined;
  const params = pairs.filter(([segment]) => isParam(segment)).map(([segment, value]) => [segment.slice(1), value]);
  return Object.fromEntries(params) as RouteParams<Path>;
};
